const panelStyle = {
  background: "white",
  borderRadius: 8,
  border: "1px solid #E5E7EB",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
};

const commonHours = (
  <p>
    Monday - Friday: 8:30am - 5:30pm
    <br /> Saturday: 8:30am - 2:30pm
    <br /> Sunday: Closed
  </p>
);

export const getStoreLocationsItems = () => [
  {
    key: "1",
    company: "Teamstar Berhad",
    label: "Teamstar HQ",
    address: (
      <p>
        No. 18, Jalan MJ 17, Taman Industri Meranti Jaya, 47120 Puchong,
        Selangor.
      </p>
    ),
    phoneNumber: <p>+6012-250 6616</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },
  {
    key: "2",
    company: "Teamstar Berhad",
    label: "Teamstar Puchong",
    address: (
      <p>
        No. 1 Jalan Utama 2/8, Taman Perindustrian Puchong Utama, 47100 Puchong,
        Selangor D.E.
      </p>
    ),
    phoneNumber: <p>+6012-328 9332 / +6017-308 2323</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },
  {
    key: "3",
    company: "Teamstar Berhad",
    label: "Teamstar Ampang",
    address: (
      <p>No. 58 Jalan 4, Taman Industri Pandah Indah, 55100 Kuala Lumpur.</p>
    ),
    phoneNumber: <p>+6012-687 4931</p>,
    hours: commonHours,
    category: "Kuala Lumpur",
    style: panelStyle,
  },
  {
    key: "4",
    company: "Teamstar Berhad",
    label: "Teamstar Klang Sentosa",
    address: (
      <p>
        No. 29G & 31G, Jalan Bendahara 3/KS7, Taman Sejati, 41200 Klang,
        Selangor D.E
      </p>
    ),
    phoneNumber: <p>+6016-262 2585</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },
  {
    key: "5",
    company: "Teamstar Berhad",
    label: "Teamstar Balakong",
    address: (
      <p>
        No. 22-G, Jalan Tengah, Cheras Selatan 118, 43200 Cheras, Selangor D.E.
      </p>
    ),
    phoneNumber: <p>+6012-235 9332</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },
  {
    key: "6",
    company: "Teamstar Berhad",
    label: "Teamstar Bandar Teknologi",
    address: (
      <p>
        No. 11 & 13 (GROUND FLOOR), JALAN 1/5, SEKSYEN 1, BANDAR TEKNOLOGI
        KAJANG, 43500 SEMENYIH, SELANGOR
      </p>
    ),
    phoneNumber: <p>+6016-228 9932</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },
  {
    key: "7",
    company: "Teamstar Berhad",
    label: "Teamstar Sungai Buloh",
    address: (
      <p>
        AL 129-1 Jalan Welfare U19, Kampung Baru Sungai Buloh, 47000 Sungai
        Buloh, Selangor D.E.
      </p>
    ),
    phoneNumber: <p>+6012-329 7931 / +6012-310 4332</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },
  {
    key: "8",
    company: "Teamstar Berhad",
    label: "Teamstar Sri Gombak",
    address: (
      <p>
        No. 21 Jalan SG1/9 Taman Sri, Gombak, 68100 Batu Caves, Selangor D.E.
      </p>
    ),
    phoneNumber: <p>+6012-266 1699</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },
  {
    key: "9",
    company: "Teamstar Berhad",
    label: "Teamstar Subang 2",
    address: (
      <p>
        No. 54, Jalan Apollo U5/189, Bandar Pinggiran Subang, Seksyen U5, 40150
        Shah Alam, Selangor D.E.
      </p>
    ),
    phoneNumber: <p>+6012-203 6692</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },
  {
    key: "10",
    company: "Teamstar Berhad",
    label: "Teamstar Batu Caves",
    address: (
      <p>
        No. 7 Jalan SBC8, Kawasan Industri Batu Caves, 68100 Batu Caves,
        Selangor. D.E.
      </p>
    ),
    phoneNumber: <p>+6019-661 6015</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },
  {
    key: "11",
    company: "Teamstar Berhad",
    label: "Teamstar Serdang",
    address: (
      <p>
        No. 12, Jalan BS 14/1, Taman Bukit Serdang, Seksyen 14, Perdagangan
        Bukit Serdang, 43300 Seri Kembangan, Selangor D.E.
      </p>
    ),
    phoneNumber: <p>+6012-226 9123</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },
  {
    key: "12",
    company: "Teamstar Berhad",
    label: "Teamstar Kajang",
    address: (
      <p>
        No. 64 Jalan SC3, Pusat Perindustrian Sungai Chua, 43000 Kajang,
        Selangor D.E.
      </p>
    ),
    phoneNumber: <p>+6012-366 5176</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },
  {
    key: "13",
    company: "Teamstar Berhad",
    label: "Teamstar Klang Utama",
    address: (
      <p>
        No. 38, Jalan Sungai Keramat 1A, Taman Klang Utama, 42100 Klang,
        Selangor D.E
      </p>
    ),
    phoneNumber: <p>+6017-238 6619</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },
  {
    key: "14",
    company: "Teamstar Berhad",
    label: "Teamstar Kepong",
    address: (
      <p>
        No. 56 Jalan Development, Taman Kepong, 52100 Kuala Lumpur, Wilayah
        Persekutuan.
      </p>
    ),
    phoneNumber: <p>+6016-223 2585</p>,
    hours: commonHours,
    category: "Kuala Lumpur",
    style: panelStyle,
  },
  {
    key: "15",
    company: "Teamstar Berhad",
    label: "Teamstar Banting",
    address: (
      <p>
        No. 16 & 18, Jalan MJ2, Taman Manggis Jaya, 42700 Banting, Selangor D.E.
      </p>
    ),
    phoneNumber: <p>+6017-680 6616</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },
  {
    key: "16",
    company: "Teamstar Berhad",
    label: "Teamstar Muar",
    address: <p>No. 4, Jalan Seri 1, Taman Seri Bakri II, 84000 Muar, Johor</p>,
    phoneNumber: <p>+6017-683 0916</p>,
    hours: commonHours,
    category: "Johor",
    style: panelStyle,
  },
  {
    key: "17",
    company: "Teamstar Berhad",
    label: "Teamstar Kuantan",
    address: (
      <p>
        No. A9 Ground Floor, Lorong IM 14/31, Bandar Indera Mahkota, 25200
        Kuantan, Pahang
      </p>
    ),
    phoneNumber: <p>+6019-280 3166</p>,
    hours: commonHours,
    category: "Pahang",
    style: panelStyle,
  },

  // Teamstar (Perak) Sdn Bhd
  {
    key: "18",
    company: "Teamstar (Perak) Sdn Bhd",
    label: "Teamstar Ipoh",
    address: (
      <p>
        No. 46 & 48, Persiaran Kilang, Pengkalan 22 Taman Pengkalan Maju, 31500
        Ipoh, Perak
      </p>
    ),
    phoneNumber: <p>+6017-996 6164</p>,
    hours: commonHours,
    category: "Perak",
    style: panelStyle,
  },
  {
    key: "19",
    company: "Teamstar (Perak) Sdn Bhd",
    label: "Teamstar Sitiawan",
    address: (
      <p>
        No. 12 & 13 Jalan Mas Suria 1, Taman Mas Suria, Kampung Koh, 32000
        Sitiawan, Perak.
      </p>
    ),
    phoneNumber: <p>+6017-434 6616</p>,
    hours: commonHours,
    category: "Perak",
    style: panelStyle,
  },

  //Teamstar (Melaka) Sdn.Bhd.
  {
    key: "20",
    company: "Teamstar (Melaka) Sdn.Bhd.",
    label: "Teamstar Puncak Bertam",
    address: <p>No. 16, Jalan PB 1A, Taman Puncak Bertam, 75260 Melaka.</p>,
    phoneNumber: <p>+6012-916 3933</p>,
    hours: commonHours,
    category: "Melaka",
    style: panelStyle,
  },
  {
    key: "21",
    company: "Teamstar (Melaka) Sdn.Bhd.",
    label: "Teamstar Semabok",
    address: <p>No. 21, Jalan SP 4, Taman Semabok Perdana, 75050 Melaka</p>,
    phoneNumber: <p>+6017-339 3378</p>,
    hours: commonHours,
    category: "Melaka",
    style: panelStyle,
  },

  //Teamstar Furniture Fittings Sdn.Bhd.
  {
    key: "22",
    company: "Teamstar Furniture Fittings Sdn.Bhd.",
    label: "Teamstar Setia Rawang",
    address: (
      <p>
        No. 38 & 40, Jalan Setia Rawang 1, Taman Setia Rawang, 48000 Rawang,
        Selangor.
      </p>
    ),
    phoneNumber: <p>+6018-232 2737</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },
  {
    key: "23",
    company: "Teamstar Furniture Fittings Sdn.Bhd.",
    label: "Teamstar Bukit Beruntung",
    address: (
      <p>
        No. 7 & 9, Jalan Melati 2b, Seksyen BB2, Bandar Bukit Beruntung, 48300
        Rawang, Selangor
      </p>
    ),
    phoneNumber: <p>+6018-4002 737</p>,
    hours: commonHours,
    category: "Selangor",
    style: panelStyle,
  },

  //Teamstar Furniture Hardware Sdn.Bhd.
  {
    key: "24",
    company: "Teamstar Furniture Hardware Sdn.Bhd.",
    label: "Teamstar Batu Pahat",
    address: (
      <p>
        No. 23 & 24 (Ground Floor), Jalan Komersil Pantai 3, Pusat Komersil
        Pantai, 83000 Batu Pahat, Johor.
      </p>
    ),
    phoneNumber: <p>+6011-6988 8688</p>,
    hours: commonHours,
    category: "Johor",
    style: panelStyle,
  },

  //Teamstar (Seremban) Sdn.Bhd.
  {
    key: "25",
    company: "Teamstar (Seremban) Sdn.Bhd.",
    label: "Teamstar Seremban 1",
    address: (
      <p>
        Lot 1508/436 (Ground Floor), Jalan Temiang, 70200 Seremban, Negeri
        Sembilan.
      </p>
    ),
    phoneNumber: <p>+6011-2316 3331</p>,
    hours: commonHours,
    category: "Negeri Sembilan",
    style: panelStyle,
  },
  {
    key: "26",
    company: "Teamstar (Seremban) Sdn.Bhd.",
    label: "Teamstar Seremban 2",
    address: (
      <p>
        No. 17, Ground Floor Jalan S2 C1, Sports Complex Square, Seremban 2,
        70300 Seremban, Negeri Sembilan.
      </p>
    ),
    phoneNumber: <p>+6011-1112 8588</p>,
    hours: commonHours,
    category: "Negeri Sembilan",
    style: panelStyle,
  },
  {
    key: "27",
    company: "Teamstar (Seremban) Sdn.Bhd.",
    label: "Teamstar Seremban Jaya",
    address: (
      <p>
        No. 509, Jalan SJ 9/1, Taman Seremban Jaya, 70450 Seremban, Negeri
        Sembilan Darul Khusus
      </p>
    ),
    phoneNumber: <p>+6018-987 2663</p>,
    hours: commonHours,
    category: "Negeri Sembilan",
    style: panelStyle,
  },
  {
    key: "28",
    company: "Teamstar (Seremban) Sdn.Bhd.",
    label: "Teamstar Rahang Kecil",
    address: (
      <p>
        No. 875, Starlight Park, Jalan Belimbing 2, 70100 Seremban, Negeri
        Sembilan
      </p>
    ),
    phoneNumber: <p>+6010-821 3131</p>,
    hours: commonHours,
    category: "Negeri Sembilan",
    style: panelStyle,
  },

  //Teamstar Reno Sdn.Bhd.
  {
    key: "29",
    company: "Teamstar Reno Sdn.Bhd.",
    label: "Teamstar Skudai",
    address: (
      <p>
        No. 30 & 32, Jalan Bistari 16, Taman Industri Jaya, 81300 Skudai, Johor
        Darul Ta'zim
      </p>
    ),
    phoneNumber: <p>+6017-803 6616</p>,
    hours: commonHours,
    category: "Johor",
    style: panelStyle,
  },
];
